import m from './module';
import Program from '../model/Program';

const path = '/program';
const type = 'Program';

class ProgramService {
  constructor($q, DataSyncService, LogService) {
    "ngInject";
    this.$q = $q;
    this.DataSyncService = DataSyncService;
    this.LogService = LogService;
    this._getAllPromise = null;
  }

  create(data) {
    return new Program(data);
  }

  getAll(config = null) {
    return this.DataSyncService.getMultipleObjects(type, path, data => this.create(data), config);
  }

  getLocalById(id) {
    return this.DataSyncService.getLocalObjectById(type, id)
      .then(result => {
        return result;
      });
  }
}

export default ProgramService;

m.service('ProgramService', ProgramService);

export const BLACKOUT_DAYS_TYPES = {
  PROGRAM: 'program',
  PROGRAM_CHAIN: 'program_chain'
}